import { Card, CardContent } from '@/components/ui';
import { CreditCard } from 'lucide-react';

/**
 * Empty state display when user has NO payments at all (no filters applied).
 * This is shown when there are truly no payments, not when filters don't match.
 * For filtered empty results, use EmptyFilteredState instead.
 */
const EmptyState = () => {
    return (
        <Card className="border-dashed animate-in fade-in-0 duration-500">
            <CardContent className="flex flex-col items-center justify-center py-16">
                <div className="rounded-full bg-muted p-4 mb-4">
                    <CreditCard className="w-8 h-8 text-muted-foreground" />
                </div>
                <h3 className="text-lg font-semibold text-foreground mb-1">
                    Aucun paiement trouvé
                </h3>
                <p className="text-sm text-muted-foreground text-center max-w-sm">
                    Cet utilisateur n'a effectué aucun paiement jusqu'à présent.
                </p>
            </CardContent>
        </Card>
    );
};

export default EmptyState;
